import { Component, OnInit, Output, ViewChild, EventEmitter } from '@angular/core';
import { MasterDataService } from '../../Services/MasterDataService';
import { ComplainService } from '../../Services/ComplainService';
import { GlitchService } from '../../Services/GlitchService';
import { BaseComponent } from '../../Library/BaseComponent';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbActiveModal, NgbModalRef, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { ComplainRegister, ComplainGSRAnswers, GSRRating } from '../../Models/RequestModels';
import { ComplainGSRQuestions } from '../../Models/ResponseModels';
import { Modules } from '../../Models/EnumModels';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'GSRAudit',
    templateUrl: './GSRAudit.html',
})

export class GSRAudit extends BaseComponent implements OnInit {
    @ViewChild('content') content;
    _complainDetail: ComplainRegister = new ComplainRegister();
    ModalRef: NgbModalRef;
    Model: Array<ComplainGSRQuestions>;
    _RequestModel: any;
    _Module: Modules;
    
    constructor(public translate: TranslateService, public toastr: ToastrService, public route: ActivatedRoute, public router: Router, public masterService: MasterDataService, public complainService: ComplainService, public glitchService: GlitchService, public modalService: NgbModal) {
        super(translate, toastr, route, router, masterService);
    }

    ngOnInit(): void {
        this._RequestModel = new ComplainGSRAnswers();
        this._RequestModel.ListGSRRating = [];
    }

    Open(ComplainDetail, _Modules: Modules): void {
        this.ClearErrors();
        if (ComplainDetail != null) {
            this._complainDetail = ComplainDetail;
        }
        this._Module = _Modules;
        if (this._Module == Modules.NoService) {
            this.complainService.Complain_GetGSRQuestions(this._complainDetail.PropertyId, this.masterService.LoggedInUserData.LanguageCode).then(data => {
                if (this.HasErrors)
                    return;

                this.Model = data.Result;
                this._RequestModel.ListGSRRating = [];

                if (data.Result.length <= 0) {
                    this.GetMultilingualToast('TS.TS_NO_GSR_SETUP', 'error');
                    return;
                }

                this.Model.forEach(item => {
                    let GSRRatingObj: any = {};
                    GSRRatingObj.QuestionId = item.QuestionId;
                    GSRRatingObj.IsCompulsory = item.IsCompulsory;
                    GSRRatingObj.Rating = 0;
                    this._RequestModel.ListGSRRating.push(GSRRatingObj);
                })
                this._RequestModel.ComplainId = this._complainDetail.ComplainId;
                this._RequestModel.PropertyId = this._complainDetail.PropertyId;
                this._RequestModel.GuestRemarks = "";
                let ngbModalOptions: NgbModalOptions = {
                    backdrop : 'static',
                    size: 'lg'
                };
                this.ModalRef = this.modalService.open(this.content, ngbModalOptions);
            });
        }
        else if (this._Module == Modules.Glitch) {
            this.glitchService.Glitch_GetGSRQuestions(this._complainDetail.PropertyId, this.masterService.LoggedInUserData.LanguageCode).then(data => {
                if (this.HasErrors)
                    return;

                this.Model = data.Result;
                this._RequestModel.ListGSRRating = [];

                if (data.Result.length <= 0) {
                    this.GetMultilingualToast('TS.TS_NO_GSR_SETUP', 'error');
                    return;
                }

                this.Model.forEach(item => {
                    let GSRRatingObj: any = {};
                    GSRRatingObj.QuestionId = item.QuestionId;
                    GSRRatingObj.IsCompulsory = item.IsCompulsory;
                    GSRRatingObj.Rating = 0;
                    this._RequestModel.ListGSRRating.push(GSRRatingObj);
                })
                this._RequestModel.ComplainId = ComplainDetail.GlitchId;
                this._RequestModel.PropertyId = ComplainDetail.PropertyId;
                this._RequestModel.GuestRemarks = "";
                let ngbModalOptions: NgbModalOptions = {
                    backdrop : 'static',
                    size: 'lg'
                };
                this.ModalRef = this.modalService.open(this.content, ngbModalOptions);
            });
          }
    }

    get ComplainModel(): ComplainRegister {
        return this._complainDetail;
    }

    get RequestModel(): ComplainGSRAnswers {
        return this._RequestModel;
    }

    onSubmit(): void {
        this.ClearErrors();

        //this.Transform();

        this.Validate();

        if (this.HasErrors)
            return;
        if (this._Module == Modules.NoService) {
            this.complainService.Complain_SaveGSRRating(this._RequestModel).then(data => {
                this.FromBaseResponse(data);
                if (this.HasErrors)
                    return;
                this.GetMultilingualToast('TS.TS_GSR_RATING_SUBMIT_SUCCESS', 'success');
                this.complainService.JobConsole_ToUpdate(this._RequestModel.ComplainId);
                this.ModalRef.close();
            })
        }
        else if (this._Module == Modules.Glitch) {
            this.glitchService.Glitch_SaveGSRRating(this._RequestModel).then(data => {
                this.FromBaseResponse(data);
                if (this.HasErrors)
                    return;
                this.GetMultilingualToast('TS.TS_GSR_RATING_SUBMIT_SUCCESS', 'success');
                this.ModalRef.close();
                this.glitchService.TriggerRequireFullRefresh();
            })
        }
        

    }

    Validate(): void {        
        if (this._RequestModel.ListGSRRating.length == 0)
            this.AddError('ERR.ERR_ANSWER_ATLEAST_1_QUE');
        this._RequestModel.ListGSRRating.forEach(item => {
            if (item.IsCompulsory && !item.Rating)
                this.AddError('ERR.ERR_RATE_COMPULSORY_QUE');
        })
        if (this._RequestModel.GuestRemarks && this._RequestModel.GuestRemarks.length > 1000)
            this.AddError('ERR.ERR_REMARK_LEN_1000');
    }
}
